import { createContext } from 'react';
import { IAccountConfig, ICustomerProfile, ICampaignLocation, ICampaignServiceArea } from 'src/lib/schemas';

interface IAccountConfigContext {
	isLoading: boolean;
	config: IAccountConfig | null;
	retries: number;
	customerProfiles: ICustomerProfile[] | null;
	isLoadingCustomerProfiles: boolean;
	setIsLoading: (isLoading: boolean) => void;
	setConfig: (config: IAccountConfig) => void;
	setCustomerProfiles: (profiles: ICustomerProfile[]) => void;
	setIsLoadingCustomerProfiles: (isLoading: boolean) => void;
	refetchCustomerProfiles: () => Promise<void>;
	updateCustomerProfile: (updatedProfile: ICustomerProfile) => void;
	addCustomerProfile: (newProfile: ICustomerProfile) => void;
	removeCustomerProfile: (profileId: string) => void;
	// Locations
	locations: ICampaignLocation[] | null;
	isLoadingLocations: boolean;
	refetchLocations: () => Promise<void>;
	addLocation: (newLocation: ICampaignLocation) => void;
	updateLocation: (updatedLocation: ICampaignLocation) => void;
	removeLocation: (locationId: string) => void;
	// Service Areas
	serviceAreas: ICampaignServiceArea[] | null;
	isLoadingServiceAreas: boolean;
	refetchServiceAreas: () => Promise<void>;
	addServiceArea: (newServiceArea: ICampaignServiceArea) => void;
	updateServiceArea: (updatedServiceArea: ICampaignServiceArea) => void;
	removeServiceArea: (serviceAreaId: string) => void;
}

const AccountConfigContext = createContext<IAccountConfigContext>({
	isLoading: false,
	config: null,
	retries: 0,
	customerProfiles: null,
	isLoadingCustomerProfiles: false,
	setIsLoading: (isLoading: boolean) => {},
	setConfig: (config: IAccountConfig) => {},
	setCustomerProfiles: (profiles: ICustomerProfile[]) => {},
	setIsLoadingCustomerProfiles: (isLoading: boolean) => {},
	refetchCustomerProfiles: async () => {},
	updateCustomerProfile: (updatedProfile: ICustomerProfile) => {},
	addCustomerProfile: (newProfile: ICustomerProfile) => {},
	removeCustomerProfile: (profileId: string) => {},
	// Locations
	locations: null,
	isLoadingLocations: false,
	refetchLocations: async () => {},
	addLocation: (newLocation: ICampaignLocation) => {},
	updateLocation: (updatedLocation: ICampaignLocation) => {},
	removeLocation: (locationId: string) => {},
	// Service Areas
	serviceAreas: null,
	isLoadingServiceAreas: false,
	refetchServiceAreas: async () => {},
	addServiceArea: (newServiceArea: ICampaignServiceArea) => {},
	updateServiceArea: (updatedServiceArea: ICampaignServiceArea) => {},
	removeServiceArea: (serviceAreaId: string) => {},
});

export default AccountConfigContext;
